export default __webpack_public_path__ + "static/media/upsell-revenue.3a74265c.svg";